var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideshowGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4854",
    "data-name": "Rectangle 4854",
    width: 22.746,
    height: 16.643,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13962",
    "data-name": "Group 13962",
    transform: "translate(-1632 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(1632 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13219",
    "data-name": "Group 13219",
    transform: "translate(1638.373 315.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12189",
    "data-name": "Group 12189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45243",
    "data-name": "Path 45243",
    d: "M5.347,13.305c-.581-.407-1.125-.769-1.648-1.158a20.3,20.3,0,0,1-3.474-3.3A.74.74,0,0,1,.213,7.8,19.156,19.156,0,0,1,6.925,2.528a10.36,10.36,0,0,1,4.651-1.009A10.661,10.661,0,0,1,15.8,2.527a.28.28,0,0,0,.381-.071c.73-.742,1.47-1.473,2.207-2.208a.739.739,0,0,1,.778-.212.716.716,0,0,1,.521.56.786.786,0,0,1-.268.764q-1.5,1.491-3,2.99Q10.427,10.33,4.428,16.307a1.235,1.235,0,0,1-.533.317.7.7,0,0,1-.784-.4.74.74,0,0,1,.157-.889q.925-.932,1.858-1.855c.061-.061.134-.11.221-.179m2.864-2.978,5.173-5.162a3.732,3.732,0,0,0-5.173,5.162",
    transform: "translate(-0.001 0)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45244",
    "data-name": "Path 45244",
    d: "M131.478,77.228c.052-.06.089-.108.132-.151.764-.764,1.527-1.528,2.3-2.286a.363.363,0,0,1,.259-.108,3.746,3.746,0,0,0,3.91-2.371,3.4,3.4,0,0,0,.233-1.759.3.3,0,0,1,.073-.227q1.685-1.694,3.379-3.378c.033-.033.068-.065.119-.114.152.111.305.218.453.331A21.155,21.155,0,0,1,145.7,70.4a.733.733,0,0,1,.036,1.012,18.7,18.7,0,0,1-7.308,5.547,9.885,9.885,0,0,1-6.852.305c-.028-.009-.054-.021-.1-.04",
    transform: "translate(-123.179 -62.616)",
    fill: "#111"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideshowGalleryIcon);
export default __webpack_public_path__ + "static/media/hideshow_gallery_icon.f0986e89d6e4548443f45607e84fe558.svg";
export { ForwardRef as ReactComponent };